<rt-dropdown class="dropdown insert-dropdown" margin-bottom-small-xx>
  <ng-container #componentOutlet />
</rt-dropdown>
